import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import DemsDefaultRecipientsTab from './tabs/DemsDefaultRecipientsTab';
import DemsListItem from '../DemsListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="demsView" itemLayout={DemsListItem} />
	},
	{
		id: 'default-recipients',
		title: 'TAB_DEFAULT_RECIPIENTS',
		content: () => <DemsDefaultRecipientsTab />
	}
];

export default tabs;
